import React from "react";

const CustomButton = ({
  title = "",
  onClick,
  wrapperClassName = "",
  textClassName = "",
  icon,
  type = "button",
}) => {
  return (
    <button
      className={`custom-button ${wrapperClassName}`}
      onClick={onClick}
      type={type}
    >
      {icon ? (
        <img src={icon} alt="button icon" className="w-[1.4rem] h-[1.4rem]" />
      ) : null}
      <div className={`font-family-medium font-size-small ${textClassName}`}>
        {title}
      </div>
    </button>
  );
};

export default CustomButton;
